import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class MenuLeftService {
    public menuLeftOpen = signal(this._readInitialMenuState());

    private _readInitialMenuState(): boolean {
        try {
            const menuLeftOpen = localStorage.getItem('menuLeftOpen');
            if (menuLeftOpen === null) return false;
            return menuLeftOpen === 'true';
        } catch {
            return false;
        }
    }

    /**
     * Toggle the menu left
     * @param forceStatus Force the status of the menu left
     */
    public toggleMenuLeft(forceStatus?: boolean): void {
        if (forceStatus !== undefined) {
            this.menuLeftOpen.set(forceStatus);
            localStorage.setItem('menuLeftOpen', forceStatus.toString());
        } else {
            this.menuLeftOpen.set(!this.menuLeftOpen());
            localStorage.setItem('menuLeftOpen', this.menuLeftOpen().toString());
        }
    }
}
